var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-container",
    {
      attrs: {
        title: _vm.$t(_vm.lblSetting.dashboardTitle),
        "hide-add-button": true,
        "hide-edit-button": true,
        "search-visible": false
      }
    },
    [
      !_vm.isServiceBookUser
        ? [
            _c(
              "v-layout",
              {
                staticClass: "statistic mt-3 ml-3",
                attrs: { row: "", wrap: "" }
              },
              [
                _c(
                  "v-flex",
                  { attrs: { xs12: "" } },
                  [
                    _c(
                      "v-card-title",
                      { attrs: { "primary-title": "" } },
                      [
                        _c(
                          "v-layout",
                          {
                            attrs: {
                              row: "",
                              wrap: "",
                              "align-center": "",
                              "justify-center": ""
                            }
                          },
                          [
                            _c("v-flex", { attrs: { xs4: "" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "statistic__icon  text-xs-center",
                                  staticStyle: { "padding-top": "2px" }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("icon-stats-o")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "headline mb-0 primary--text statistic__text-title statistic--border-bottom2 statistic__without-border"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.lblSetting.dashboardStatistic
                                        )
                                      )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs4: "" } },
                              [_c("v-spacer")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs4: "" } },
                              [
                                _c("base-date-picker-range", {
                                  attrs: {
                                    customClass: "statistic__range-button"
                                  },
                                  on: { change: _vm.handleChange },
                                  model: {
                                    value: _vm.dtSearchParameter,
                                    callback: function($$v) {
                                      _vm.dtSearchParameter = $$v
                                    },
                                    expression: "dtSearchParameter"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { staticStyle: { height: "200px" }, attrs: { xs6: "" } },
                  [
                    !_vm.coTicketStatisticLoading
                      ? _c("GChart", {
                          attrs: {
                            type: "ColumnChart",
                            data: _vm.coStatisticReportedData,
                            options: _vm.getStatisticResolvedOptions(
                              "blockReportedTicketStatistic"
                            )
                          }
                        })
                      : _c("home-chart-loader")
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { staticStyle: { height: "200px" }, attrs: { xs6: "" } },
                  [
                    !_vm.coTicketStatisticLoading
                      ? _c("GChart", {
                          attrs: {
                            type: "ColumnChart",
                            data: _vm.coStatisticResolvedData,
                            options: _vm.getStatisticResolvedOptions(
                              "blockResolvedTicketStatistic",
                              ""
                            )
                          }
                        })
                      : _c("home-chart-loader")
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.$route.meta["stat_view_resolution_average_time"]
              ? _c(
                  "v-layout",
                  {
                    staticClass: "statistic__total-hours  mt-3 ml-3  px-5",
                    attrs: { row: "", wrap: "" }
                  },
                  [
                    _c(
                      "v-flex",
                      {
                        staticClass: "primary--text px-5 ",
                        staticStyle: {
                          "font-weight": "500",
                          "font-size": "13px"
                        },
                        attrs: { xs12: "" }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(_vm.lblSetting.blockTotalHoursStatistic, {
                                days: 30
                              })
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("v-card-title", { attrs: { "primary-title": "" } }, [
                      _c("div", { staticClass: "xs8" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "statistic__icon statistic__without-border"
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "primary", medium: "" } },
                              [_vm._v("icon-time")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "h2",
                          {
                            staticClass:
                              "headline mb-0 primary--text statistic__text-title statistic__text-title--time statistic--border-bottom2 statistic__without-border"
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.coAverageResolutionTime)
                            )
                          ]
                        )
                      ])
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$route.meta["stat_view_ticket_by_manager"]
              ? _c(
                  "div",
                  [
                    _vm.getVisibility("member_tabular")
                      ? _c(
                          "v-layout",
                          {
                            staticClass: "statistic mt-3 ml-3",
                            attrs: { row: "", wrap: "" }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [
                                _c(
                                  "v-card-title",
                                  { attrs: { "primary-title": "" } },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c("v-flex", { attrs: { xs12: "" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "statistic__icon text-xs-center"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [_vm._v("icon-members")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "headline mb-0 primary--text statistic__text-title statistic--border-bottom2 statistic__without-border"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .dashboardMemberStatistic
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.coMemberStatisticLoading
                              ? _c(
                                  "v-flex",
                                  { attrs: { xs12: "" } },
                                  [
                                    _c(
                                      "v-card",
                                      {
                                        staticClass:
                                          "statistic__members pa-2 mx-3"
                                      },
                                      [
                                        _c(
                                          "v-data-table",
                                          {
                                            staticClass:
                                              "dr-table--transparent",
                                            attrs: {
                                              headers: _vm.headers,
                                              items: _vm.coMembers,
                                              "hide-actions": ""
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "items",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticStyle: {
                                                          width: "30px",
                                                          height: "30px"
                                                        }
                                                      },
                                                      [
                                                        props.item.link &&
                                                        props.item.link.length >
                                                          0
                                                          ? _c("img", {
                                                              staticStyle: {
                                                                width: "30px",
                                                                height: "30px",
                                                                "border-radius":
                                                                  "15px"
                                                              },
                                                              attrs: {
                                                                src:
                                                                  props.item
                                                                    .link,
                                                                alt: ""
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "primary--text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              props.item
                                                                .firstname
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              props.item
                                                                .lastname
                                                            )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center primary--text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item
                                                              .totalInProgressTicket
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center primary--text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item
                                                              .totalTicket
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center primary--text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item
                                                              .averageResolutionTime
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ])
                                          },
                                          [
                                            [
                                              _vm._v(
                                                "\n                No record was found\n              "
                                              )
                                            ]
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "v-flex",
                                  { attrs: { xs12: "" } },
                                  [_c("home-table-loader")],
                                  1
                                )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$route.meta["stat_view_ticket_by_contractor"]
              ? _c(
                  "div",
                  [
                    _c(
                      "v-layout",
                      {
                        staticClass: "statistic mt-3 ml-3",
                        attrs: { row: "", wrap: "" }
                      },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _c(
                              "v-card-title",
                              { attrs: { "primary-title": "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c("v-flex", { attrs: { xs12: "" } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "statistic__icon text-xs-center"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v("icon-members")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "headline mb-0 primary--text statistic__text-title statistic--border-bottom2 statistic__without-border"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.lblSetting
                                                    .dashboardContractorStatistic
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.coMemberStatisticLoading
                          ? _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "statistic__members pa-2 mx-3"
                                  },
                                  [
                                    _c(
                                      "v-data-table",
                                      {
                                        staticClass: "dr-table--transparent",
                                        attrs: {
                                          headers: _vm.headersViewByContractor,
                                          items: _vm.coContractors,
                                          "hide-actions": ""
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  {
                                                    staticStyle: {
                                                      width: "30px",
                                                      height: "30px"
                                                    }
                                                  },
                                                  [
                                                    props.item.link &&
                                                    props.item.link.length > 0
                                                      ? _c("img", {
                                                          staticStyle: {
                                                            width: "30px",
                                                            height: "30px",
                                                            "border-radius":
                                                              "15px"
                                                          },
                                                          attrs: {
                                                            src:
                                                              props.item.link,
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "primary--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          props.item.firstname
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          props.item.lastname
                                                        )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center primary--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item
                                                          .totalInProgressTicket
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center primary--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item
                                                          .totalResolvedTicket
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center primary--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item.totalTicket
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      },
                                      [
                                        [
                                          _vm._v(
                                            "\n                No record was found\n              "
                                          )
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [_c("home-table-loader")],
                              1
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$route.meta["stat_view_ticket_by_block"]
              ? _c(
                  "div",
                  [
                    _c(
                      "v-layout",
                      {
                        staticClass: "statistic mt-3 ml-3",
                        attrs: { row: "", wrap: "" }
                      },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _c(
                              "v-card-title",
                              { attrs: { "primary-title": "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c("v-flex", { attrs: { xs11: "" } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "statistic__icon text-xs-center"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v("icon-park")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "headline mb-0 primary--text statistic__text-title statistic--border-bottom2 statistic__without-border"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.lblSetting.blockTitle
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs1: "" } },
                                      [
                                        _c(
                                          "v-tooltip",
                                          { attrs: { top: "" } },
                                          [
                                            _c(
                                              "template",
                                              { slot: "activator" },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      color: "secondary"
                                                    },
                                                    on: {
                                                      click: _vm.downloadCSV
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("icon-download")
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "Cliquez ici pour télécharger le tableau."
                                              )
                                            ])
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.coMemberStatisticLoading
                          ? _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "statistic__members pa-2 mx-3"
                                  },
                                  [
                                    _c(
                                      "v-data-table",
                                      {
                                        staticClass: "dr-table--transparent",
                                        attrs: {
                                          headers: _vm.headersViewByBlock,
                                          items: _vm.coBlocks,
                                          "hide-actions": ""
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  {
                                                    staticStyle: {
                                                      width: "30px",
                                                      height: "30px"
                                                    }
                                                  },
                                                  [
                                                    props.item.link &&
                                                    props.item.link.length > 0
                                                      ? _c("img", {
                                                          staticStyle: {
                                                            width: "30px",
                                                            height: "30px",
                                                            "border-radius":
                                                              "15px"
                                                          },
                                                          attrs: {
                                                            src:
                                                              props.item.link,
                                                            alt: ""
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "primary--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(props.item.name)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center primary--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item
                                                          .totalInProgressTicket
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center primary--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item
                                                          .totalResolvedTicket
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center primary--text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item.totalTicket
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ])
                                      },
                                      [
                                        [
                                          _vm._v(
                                            "\n                No record was found\n              "
                                          )
                                        ]
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [_c("home-table-loader")],
                              1
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : [
            _c(
              "v-container",
              {
                attrs: {
                  "grid-list-md": "",
                  "text-xs-left": "",
                  "align-content-space-between": ""
                }
              },
              [
                _c(
                  "v-layout",
                  {
                    staticClass: "statistic mt-3 ml-3",
                    attrs: { row: "", wrap: "" }
                  },
                  [
                    _vm.isServiceBookAgency || _vm.isServiceBookOwner
                      ? _c(
                          "v-flex",
                          { attrs: { xs4: "", "pa-2": "" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticStyle: { "border-radius": "15px" },
                                attrs: { color: "whitePure" }
                              },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          row: "",
                                          wrap: "",
                                          "align-center": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", pa3: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  row: "",
                                                  wrap: "",
                                                  "align-left": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "statistic__icon statistic__without-border"
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "primary",
                                                          medium: ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "icon-service-book-home"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "headline mb-0 primary--text statistic__text-title statistic__text-title--time statistic--border-bottom2 statistic__without-border"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.lblSetting
                                                              .sbTitle
                                                          )
                                                        )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            !_vm.coServiceBookLoading
                                              ? _c("GChart", {
                                                  attrs: {
                                                    type: "PieChart",
                                                    data:
                                                      _vm.coServiceBookChartData
                                                        .serviceBook,
                                                    options: _vm.getServiceBookChartOptions()
                                                  }
                                                })
                                              : _c("home-chart-loader")
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isServiceBookAgency || _vm.isServiceBookOwner
                      ? _c(
                          "v-flex",
                          { attrs: { xs4: "", "pa-2": "" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticStyle: { "border-radius": "15px" },
                                attrs: { color: "whitePure" }
                              },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          row: "",
                                          wrap: "",
                                          "align-center": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", pa3: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  row: "",
                                                  wrap: "",
                                                  "align-left": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "statistic__icon statistic__without-border"
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "primary",
                                                          medium: ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "icon-document-home"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "headline mb-0 primary--text statistic__text-title statistic__text-title--time statistic--border-bottom2 statistic__without-border"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Documents"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            !_vm.coServiceBookLoading
                                              ? _c("GChart", {
                                                  attrs: {
                                                    type: "PieChart",
                                                    data:
                                                      _vm.coServiceBookChartData
                                                        .document,
                                                    options: _vm.getServiceBookChartOptions()
                                                  }
                                                })
                                              : _c("home-chart-loader")
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isServiceBookAgency || _vm.isServiceBookOwner
                      ? _c(
                          "v-flex",
                          { attrs: { xs4: "", "pa-2": "" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticStyle: { "border-radius": "15px" },
                                attrs: { color: "whitePure" }
                              },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          row: "",
                                          wrap: "",
                                          "align-center": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs12: "", pa3: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  row: "",
                                                  wrap: "",
                                                  "align-left": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "statistic__icon statistic__without-border"
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "primary",
                                                          medium: ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "icon-ticket-home"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "headline mb-0 primary--text statistic__text-title statistic__text-title--time statistic--border-bottom2 statistic__without-border"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Demandes"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            !_vm.coServiceBookLoading
                                              ? _c("GChart", {
                                                  attrs: {
                                                    type: "PieChart",
                                                    data:
                                                      _vm.coServiceBookChartData
                                                        .ticket,
                                                    options: _vm.getServiceBookChartOptions()
                                                  }
                                                })
                                              : _c("home-chart-loader")
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.isServiceBookAgency || _vm.isServiceBookOwner
              ? _c(
                  "v-layout",
                  {
                    attrs: {
                      "mt-2": "",
                      "pt-2": "",
                      "justify-center": "",
                      row: "",
                      warp: ""
                    }
                  },
                  [
                    _c(
                      "v-flex",
                      {
                        staticClass: "d-flex align-center",
                        attrs: { xs4: "", sm4: "" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass:
                              "white--text text-none font-weight-bold",
                            attrs: { round: "", color: "secondary" },
                            on: {
                              click: function($event) {
                                _vm.StripeBuyServiceBook()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.lblSetting.serviceBookSidebar
                                      .buy_service_books
                                  )
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "base-modal-duplicate",
              {
                attrs: {
                  "only-close-action": "",
                  icon: "add_shopping_cart",
                  "icon-type": "icon",
                  "submit-btn-title": "Fermer",
                  title: _vm.$t(
                    _vm.lblSetting.serviceBookSidebar.buy_service_books
                  ),
                  "max-width": "80%",
                  "is-dark-title": ""
                },
                model: {
                  value: _vm.buyServiceBookModal,
                  callback: function($$v) {
                    _vm.buyServiceBookModal = $$v
                  },
                  expression: "buyServiceBookModal"
                }
              },
              [
                _c("modal-buy-service-book", {
                  attrs: { serviceBookProduct: _vm.serviceBookProduct }
                })
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cc10e0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cc10e0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/home/template.html
// module id = null
// module chunks = 